import Rollbar from 'rollbar';
import { Auth } from 'aws-amplify';
import Debug from 'debug';

import config from '../config';

const debug = Debug('tfs');
debug.log = console.info.bind(console); // eslint-disable-line no-console

function getRollbar(user) {
  return new Rollbar({
    ...config.rollbar,
    payload: {
      environment: config.rollbar.environment,
      person: { id: user?.username },
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: import.meta.env.VITE_CODE_VERSION,
          guess_uncaught_frames: true,
        },
      },
    },
  });
}

export async function error(err, meta) {
  const user = await Auth.currentAuthenticatedUser().catch(() => null);
  // eslint-disable-next-line no-console
  console.error(err);
  getRollbar(user).error(err, meta);
}

export async function info(...args) {
  debug(...args);
}
